<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Detalhes">
          <b-col sm="6" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="info">
                    <small class="text-muted">últimos 10 dias</small><br>
                    <strong class="h4">Contas Recebidas</strong>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
          </b-col>
          <b-table class="mb-0 table-outline" responsive="sm" hover :items="tableItems" :fields="tableFields" head-variant="light">
            <div slot="avatar" class="avatar" slot-scope="item">
              <img :src="item.value.url" class="img-avatar" alt="">
              <span class="avatar-status" v-bind:class="{ 'bg-info': item.value.status == 'info', 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
            </div>
            <div slot="user" slot-scope="item">
              <div>
                <strong>{{item.value.name}}</strong>
              </div>
              <div class="small text-muted">
                <span>
                  Documento: {{item.value.registered}}
                </span>
                <span>
                  [{{item.value.parcela}}]
                </span>
              </div>
            </div>
            <i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
            <div slot="usage" slot-scope="item">
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{item.value.valor}}</strong>
                  <strong>({{item.value.value}}%)</strong>
                </div>
                <div class="float-right">
                  <small class="text-muted">{{item.value.period}}</small>
                </div>
              </div>
              <b-progress height={} class="progress-xs" v-model="item.value.value" :variant="variant(item.value.value)"></b-progress>
            </div>
            <div slot="activity" slot-scope="item">
              <div class="small text-muted">Último Pagamento</div>
                <template v-if="item.value == '0'">
                  <strong>Sem Movimento</strong>
                </template>
                <template v-else>
                  <strong>{{item.value}} Dias Atrás</strong>
                </template>
            </div>
          </b-table>
          
        </b-card>
        <b-btn type="button" variant="primary" @click="$router.go('-1')" ><i class="fa fa-arrow-left"></i> Voltar</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from '../../components/'

export default {
  name: 'dashboard',
  components: {
    Callout
  },
  data: function () {
    return {
      tableItems: [
        {
          avatar: { url: '', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          activity: '10 sec ago'
        }
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'Fornecedor'
        },
        usage: {
          label: 'Valor'
        },
        activity: {
          label: 'Atividade'
        }
      }
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    listarTitulos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/recebido/listartitulos10dias')
      let promise = this.$http.get(uri)
      this.tableItems = []
      promise.then((data) => {
        if (data) {
          let i
          /*
          let item = {
            avatar: { url: '', status: 'success' },
            user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
            usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
            activity: '10 sec ago'
          }
          */

          for (i = 0; i < data.data.length; i++) {
            this.tableItems.push({
              avatar: {url: '', status: this.variant(data.data[i].PERCENTUAL)},
              user: { name: data.data[i].NOME_CLIENTE, new: true, registered: data.data[i].DOCUMENTO, parcela: data.data[i].PARCELA },
              usage: { value: data.data[i].PERCENTUAL, valor: this.numberToReal(data.data[i].VALOR_ABERTO), period: new Date(data.data[i].DATA_INICIO).toISOString().substr(0, 10).split('-').reverse().join('/') + ' - ' + new Date(data.data[i].DATA_FIM).toISOString().substr(0, 10).split('-').reverse().join('/') },
              activity: data.data[i].ULT_BAIXA_DIAS == null ? '0' : data.data[i].ULT_BAIXA_DIAS
            })
            // titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          // this.areceber10DiasTitulos = titulos
        }
      })
    }
  },
  created () {
    this.listarTitulos10Dias()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/RecebidoUltimosDezDias.vue